import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function logout(token) {
  const response = await axios.post(`${REACT_APP_API}/auth/logout`, { token })
  // Eliminar preferencia de mostrar solo no leídos
  localStorage.removeItem('showUnreadOnly')
  return response?.data
}
